import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import $rq from '@/api/api';
import type { Order, Pagination } from '@/interfaces/common';

// Types and interfaces

interface OrdersResponse {
    orders: Order[];
    pagination: Pagination;
}

interface OrderState {
    orders: Order[];
    Activeorders: Order | Record<string, unknown>;
    orderPagination: Partial<Pagination>;
}

// Default state
const defaultState: OrderState = {
    orders: [],
    Activeorders: {},
    orderPagination: {},
};

export const orderModule: Module<OrderState, RootState> = {
    state: { ...defaultState },

    getters: {
        orders: (state: OrderState): Order[] => state.orders,
        activeOrders: (state: OrderState): Order | Record<string, unknown> => state.Activeorders,
        orderPagination: (state: OrderState): Partial<Pagination> => state.orderPagination,
    },

    mutations: {
        setOrders(state: OrderState, content: OrdersResponse): void {
            state.orders =
                content.pagination.currentPage !== state.orderPagination.currentPage
                    ? [...state.orders, ...content.orders]
                    : content.orders;
            state.orderPagination = content.pagination;
        },
        setActiveOrders(state: OrderState, orders: Order[]): void {
            state.Activeorders = orders.find((or: Order) => or.active) || {};
        },
        resetOrders(state: OrderState): void {
            Object.assign(state, { ...defaultState });
        },
    },

    actions: {
        async getOrderItems(
            { commit, dispatch },
            payload: { siteId: string; params?: Record<string, unknown> },
        ): Promise<void> {
            try {
                if (!payload.params) {
                    payload.params = {};
                }
                const { data } = await $rq.getOrders(payload.siteId, payload.params);
                commit('setOrders', data);
                commit('setActiveOrders', data.orders);
            } catch (err) {
                console.error('Error fetching order items:', err);
                dispatch('resetOrders');
            }
        },

        resetOrders({ commit }): void {
            commit('resetOrders');
        },
    },
};
